<template>
    <div class="container fancoil-container">
        <div class="handle-box">
            <el-form :inline="true" style="display:inline-block;">
                <el-form-item label="风盘类型">
                    <el-select v-model="editData.dataType" @change="handleChose">
                        <el-option label="风机盘管" :value="1"></el-option>
                        <el-option label="风柜" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="fr">
                <el-button type="primary" @click="handleEdit({})" v-has="'device_parameters'">{{addDeviceStr}}</el-button>
            </div>
        </div>
        <div v-show="editData.dataType===1">
            <el-table :data="fancoilsData" style="width: 100%">
                <el-table-column prop="FancoilModel" label="风盘型号">
                </el-table-column>
                <el-table-column prop="MotorPower" label="电机功率">
                </el-table-column>
                <el-table-column prop="RateAirAmount" label="额定风量">
                </el-table-column>
                <el-table-column prop="HighSpeedHeat" label="高风档换热量">
                </el-table-column>
                <el-table-column prop="MediumSpeedHeat" label="中风档换热量">
                </el-table-column>
                <el-table-column prop="LowSpeedHeat" label="低风档换热量">
                </el-table-column>
                <el-table-column prop="FloorHeating" label="地暖换热量">
                </el-table-column>
                <el-table-column label="操作" width="150px">
                    <template slot-scope="scope">
                        <el-button @click="handleEdit(scope.row)" size="small"  v-has="'device_parameters'">编辑</el-button>
                        <el-button @click="handleDetele(scope.row)" type="danger"  v-has="'device_parameters'" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-show="editData.dataType===2">
            <el-table :data="FancupboardData" style="width: 100%">
                <el-table-column prop="FanCupboardModel" label="风柜型号">
                </el-table-column>
                <el-table-column prop="CupboardHeat" label="风柜换热量">
                </el-table-column>
                <el-table-column prop="CupboardPower" label="电机功率">
                </el-table-column>
                <el-table-column prop="Description" label="备注">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="handleEdit(scope.row)" size="small"  v-has="'device_parameters'">编辑</el-button>
                        <el-button @click="handleDetele(scope.row)" type="danger" size="small"  v-has="'device_parameters'">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        
        <fancoil-form 
            @handleCloseDialog="listenDialogClose" 
            :editData="editData" 
            :visible="visible1"
            v-if="visible1"
        ></fancoil-form>
        <cabinet-form 
            @handleCloseDialog="listenDialogClose"
            :editData="editData" 
            :visible="visible2"
            v-if="visible2"
        ></cabinet-form>
    </div>

</template>

<script>
import Service from '@/api/Service'
import {$Alert} from '@/utils/utils'
import FancoilForm from "./fancoilForm/FancoilForm";
import CabinetForm from "./fancoilForm/CabinetForm";
export default {
    name:'addfancoil',
    inject: ['reload'],
    data() {
        return {
            fancoilsData: [],   //  风盘列表
            FancupboardData: [],    //  风柜列表
            editData: {
                dataType: 1,
            },
            visible1: false,
            visible2: false,
        };
    },
    computed: {
        addDeviceStr() {
            if(this.editData.dataType === 1) {
                return "+ 添加风盘"
            } else {
                return "+ 添加风柜"
            }
        }
    },
    components: {
        FancoilForm,
        CabinetForm
    },
    created() {
        this.getFancoilsData();
        this.getFancupboardData();
    },
    methods: {
        handleChose(val) {
            this.dataType = val;
        },
        // 获取风盘
        async getFancoilsData() {
            let data = await Service.getFancoils();
            if(data) {
                data = data == 'success' ? [] : data;
                this.fancoilsData = data
            }
        },
        // 获取风柜
        async getFancupboardData() {
            let data = await Service.getFancupboard();
            if(data) {
                data = data == 'success' ? [] : data;
                this.FancupboardData = data
            }
        },
        // 编辑风盘
        handleEdit(row) {
            let type = this.editData.dataType;
            this.editData = Object.assign({dataType: type}, row);
            if(type == 1) {
                this.visible1 = true;
            }else{
                this.visible2 = true;
            }
        },
        // 删除风盘
        handleDetele(row) {
            let name = this.editData.dataType == 1 ? row.FancoilModel : row.FanCupboardModel;
            $Alert(`是否确认删除 ${name}`).then( async (bool)=>{
                if(bool){
                    let data
                    if(this.editData.dataType == 1){
                        // 删除风盘
                        data = await Service.delFancoils({OID: row.OID});
                    }else{
                        // 删除风柜
                        data = await Service.delFancupboard({OID: row.OID});
                    }
                    if(data) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.reload();
                    }
                }
           });
        },
        // 添加风盘风柜刷新数据
        listenDialogClose(value) {
            this.visible1 = false;
            this.visible2 = false;
            if(value) {
                if(this.editData.dataType == 1){
                    this.getFancoilsData(); 
                }
                else{
                    this.getFancupboardData();
                }
                
            }
        },
    }
};
</script>
<style scoped>
.fancoil-container {
    padding: 24px 32px;
    background: #fff;
}
</style>
